import BankAccountsList from '@/components/bankAccounts/BankAccountsList';
import {
  SVListFilters,
  SVListPagination,
  SVListStats,
  SVLoader,
} from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { FILTERS } from '@/constants/filters';
import { useGetBankAccountsList } from '@/hooks/requests/useBankAccounts';
import useBuildListFilters from '@/hooks/requests/useBuildListFilters';
import { formatCurrency } from '@/utils/currency';
import { Card, Stack, Typography } from '@mui/material';

export default function BankAccountsListPage() {
  const {
    accounts,
    aggregateInfo,
    totalRecordCount,
    accountsIsPending,
    isSuccess,
  } = useGetBankAccountsList();

  const { defaultValues, filters } = useBuildListFilters({
    enabled: isSuccess,
    extraFilters: [FILTERS.BANK_ACCOUNT_STATUS],
    hasCompanyFilter: true,
    hasBusinessFilter: true,
    hasCustomerFilter: true,
    hasTeammateFilter: true,
  });
  const stats = {
    'Total Available Balance': formatCurrency({
      amount: aggregateInfo?.totalAvailableBalance?.value ?? 0,
    }),
    Transactions: aggregateInfo?.totalTransactions ?? 0,
    Deposits: aggregateInfo?.totalDeposits ?? 0,
    Withdrawals: aggregateInfo?.totalWithdrawals ?? 0,
  };

  return (
    <DefaultLayout
      header={`Bank Accounts ${totalRecordCount ? `(${totalRecordCount})` : ''}`}>
      <SVListFilters
        defaultValues={defaultValues}
        filters={filters}
        searchLabel="Search by holders name, email, Sweeps Bank Account ID"
      />
      {accountsIsPending ? (
        <SVLoader />
      ) : (
        <>
          {accounts.length === 0 ? (
            <Card>
              <Typography>No results found</Typography>
            </Card>
          ) : (
            <Stack spacing={2}>
              {aggregateInfo && <SVListStats stats={stats} />}
              <BankAccountsList accounts={accounts} />
              <SVListPagination totalRecordCount={totalRecordCount} />
            </Stack>
          )}
        </>
      )}
    </DefaultLayout>
  );
}
